import React, {
    useState,
    Children,
    isValidElement,
} from 'react'
import PropTypes from 'prop-types'
import { getStyles } from '@conversionbuddy/Layout'
import styled from 'styled-components'
import { useTranslation } from '../../../hooks/useTranslation'
import { Clickable } from '../../Clickable'
import { useTracking } from '../../../hooks/useTracking'

const StyledCopytoClipboard = styled(Clickable)`
    ${getStyles()}
`
export const CopyToClipboardTextCopied = styled.div`
    ${getStyles()}
`
export const CopyToClipboardText = styled.div`
    ${getStyles()}
`
//icon oder ähnliches
export const CopyToClipboardElement = styled.div`
    ${getStyles()}
`
//icon, confirmation popup, oder ähnliches
export const CopyToClipboardElementCopied = styled.div`
    ${getStyles()}
`

export const CopyToClipboard = ({
    children,
    code,
    ...props
}) => {
    const [isCopied, setIsCopied] = useState(false)
    const [TrackingTypes, track] = useTracking()

    const label = useTranslation(
        'accessibility.layout.voucher.copy',
    )

    const handleClick = () => {
        navigator?.clipboard?.writeText?.(code).then(() => {
            setIsCopied(true)
        })

        track({
            type: TrackingTypes.CLICK_INTERNAL_PROMOTION,
        })
    }

    const transformedChildren = Children.map(
        children,
        (child) => {
            if (isValidElement(child)) {
                if (
                    child.type === CopyToClipboardTextCopied
                ) {
                    return isCopied ? child : null
                }

                if (child.type === CopyToClipboardText) {
                    return isCopied ? null : child
                }

                if (child.type === CopyToClipboardElement) {
                    return isCopied ? null : child
                }

                if (
                    child.type ===
                    CopyToClipboardElementCopied
                ) {
                    return isCopied ? child : null
                }
            }
        },
    )

    return code ? (
        <StyledCopytoClipboard
            {...props}
            aria-label={label}
            handler={handleClick}
        >
            {transformedChildren}
        </StyledCopytoClipboard>
    ) : null
}

CopyToClipboard.propTypes = {
    code: PropTypes.string,
    children: PropTypes.node.isRequired,
}

CopyToClipboard.defaultProps = {
    code: '',
}
